import { render, staticRenderFns } from "./MandalaEvaluationFormActionGoalItem.vue?vue&type=template&id=d05f8f6a&scoped=true&"
import script from "./MandalaEvaluationFormActionGoalItem.vue?vue&type=script&lang=js&"
export * from "./MandalaEvaluationFormActionGoalItem.vue?vue&type=script&lang=js&"
import style0 from "./MandalaEvaluationFormActionGoalItem.vue?vue&type=style&index=0&id=d05f8f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05f8f6a",
  null
  
)

export default component.exports